<template>
<div class="design-side art-area">
    <div v-for="(artDesignFromList, index) in this.uStore.userDesigns[
            store.currentEditingProps.productId
        ].designs[store.currentEditingProps.variantId].imgVariants[store.currentEditingProps.imageToPreview]
            .arts" :key="index" class="elements-container">
        <div :class="store.currentEditingProps.currentPreview == 'art' && store.currentEditingProps.currentPreviewIndex == index ? 'element-div ele-div-active' : 'element-div'">
            <div class="ele-title-line">
                <span class="ele-title" style="display:flex; justify-content: space-between; align-items: flex-start; height: fit-content;">
                    
                    <div class="search-container">
                        <img src="../../../public/Icons-Vector.png" alt="Search Icon">
                        <input class="ele-input" type="text" :placeholder="'Search..'" v-model="searchArtText" @change="getArtBySearch()" />
                    </div>

                </span>
                <span class="remove-container" @click.stop="delArt(index)">
                    <img class="remove-img" src="../../../public/Icons-DeleteBlackIcon.png" />
                </span>
            </div>
            <div class="chooseArt-container">
                <div class="art-categories-container">
                    <div v-for="(artCategory, indexArtCategory) in getArtBySearchGroupByCategories()" :key="indexArtCategory">
                        <span class="art-category-title">{{ artCategory.categoryName }}</span>
                        <div class="gallery-elements" style="border: 0px; padding: 0px;">
                            <div v-for="(art, categoryIndex) in artCategory.artsList" :key="categoryIndex" @click="changeArt(art, index)" :class="artDesignFromList.artID == art.artID ? 'gallery-item gallery-item-active' : 'gallery-item'">
                                <DSTPreview :dwidth="35" :dheight="35" :dstFile="art.sizes[Object.keys(art.sizes)[0]].dstfile
                                        " :layersColors="art.defaultColors" :left="null" :top="null">
                                </DSTPreview>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="colors-select-line" ref="colorsSelectLineRef">
                    <div v-for="(layer, colorIndex) in this.uStore.userDesigns[
                            store.currentEditingProps.productId
                        ].designs[store.currentEditingProps.variantId].imgVariants[
                            store.currentEditingProps.imageToPreview
                        ].arts[index].colors" :key="colorIndex">
                        <SelectColor v-model="this.uStore.userDesigns[store.currentEditingProps.productId].designs[
                                store.currentEditingProps.variantId
                            ].imgVariants[store.currentEditingProps.imageToPreview].arts[
                                index
                            ].colors[colorIndex]">
                        </SelectColor>
                    </div>

                    <svg class="vertical-line" height="26" width="3">
                        <line x1="0" y1="0" x2="0" y2="26" style="stroke:#E6E6E6;stroke-width:3" />
                    </svg>

                    <span class="change-size-container">
                        <span @click.stop="increaseSize(index)" style="cursor: pointer;">+</span>
                        <span>
                            <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.846 7.83H2.59L1.806 10H0.462L3.99 0.298H5.46L8.974 10H7.63L6.846 7.83ZM6.482 6.794L4.718 1.866L2.954 6.794H6.482ZM14.8126 8.295H11.4686L10.8526 10H9.79659L12.5686 2.377H13.7236L16.4846 10H15.4286L14.8126 8.295ZM14.5266 7.481L13.1406 3.609L11.7546 7.481H14.5266Z" fill="#2D2D2D" />
                            </svg>
                        </span>
                        <span @click.stop="decreaseSize(index)" style="cursor: pointer;">-</span>
                    </span>

                </div>
            </div>
           
        </div>
    </div>
    <span class="btn-add-element" title="Add New Art" style="width: 140px;" @click="addArtToDesign()">
        + Add New Art
    </span>
</div>
</template>

<script>
import {
    designerStore
} from "@/stores/designerStore";
import {
    userStore
} from "@/stores/userStore";
// import { ref } from "vue";
import DSTPreview from "../DSTPreview.vue";
import SelectColor from "../SelectColor.vue";
export default {
    components: {
        DSTPreview,
        SelectColor,

    },
    setup() {
        const store = designerStore();
        const uStore = userStore();
        return {
            store,
            uStore,
        };
    },
    data() {
        return {
            searchArtText: "",
            filterByArtCategories: [],
            selectedButton: [],

            //upload image data
            uploadings: [],
            uploadsProgress: [],
            uploadedFilesName: [], // To store the name of the uploaded file
        }
    },
    props: {
        changeStyleByRef: {
            type: Function,
            required: true
        },
        increaseArtSize: {
            type: Function,
            required: true
        },
        decreaseArtSize: {
            type: Function,
            required: true
        },
        changeArc: {
            type: Function,
            required: true
        },
        resetArc: {
            type: Function,
            required: true
        },
    },

    methods: {
        getArtBySearchGroupByCategories() {
            //מסדר את כל התמונות לפי קטגוריות כאשר הקטגוריה עוד מופיעה בסוף הרשימה
            var resultByCategories = {};
            var catName = "";
            var moreCategory = null; // Store the 'More' category separately
            var myArtsCategory = null; // Store the 'More' category separately
            this.store.getAllArtsBySearchText(this.searchArtText).filter(f => {
                var moreObj = Object.values(this.store.allArtCategories.value).find(item => item.categoryName == 'More');
                // var myArtsObj = Object.values(this.store.allArtCategories.value).find(item => item.categoryName == 'My Arts');
                var moreIndex = moreObj != null ? moreObj.categoryID : -1;
                // var myArtsIndex = myArtsObj != null ? myArtsObj.categoryID : -1;
                if (this.filterByArtCategories.length == 0) {
                    catName = f.artID >= 100000 ? 'My Arts' : ((f.artCategoryID == undefined || (moreIndex != -1 && f.artCategoryID == moreIndex)) ? 'More' : this.store.allArtCategories.value[f.artCategoryID].categoryName);
                    if (catName === 'My Arts') {
                        if (myArtsCategory == null) {
                            myArtsCategory = {
                                categoryName: 'My Arts',
                                artsList: [f]
                            };
                        } else {
                            myArtsCategory.artsList.push(f);
                        }
                    } else if (catName === 'More') {
                        if (moreCategory == null) {
                            moreCategory = {
                                categoryName: 'More',
                                artsList: [f]
                            };
                        } else {
                            moreCategory.artsList.push(f);
                        }
                    } else {
                        if (resultByCategories[catName] == undefined) {
                            resultByCategories[catName] = {
                                categoryName: (f.artCategoryID == undefined || (moreIndex != -1 && f.artCategoryID == moreIndex)) ? 'More' : this.store.allArtCategories.value[f.artCategoryID].categoryName,
                                artsList: [f]
                            };
                        } else {
                            resultByCategories[catName].artsList.push(f);
                        }
                    }
                } else if (f.artCategoryID != undefined && this.filterByArtCategories.includes(f.artCategoryID)) {
                    catName = this.store.allArtCategories[f.artCategoryID].categoryName;
                    if (resultByCategories[catName] == undefined) {
                        resultByCategories[catName] = {
                            categoryName: this.store.allArtCategories.value[f.artCategoryID].categoryName,
                            artsList: [f]
                        };
                    } else {
                        resultByCategories[catName].artsList.push(f);
                    }
                }
            });

            // If 'More' category exists, add it to the result
            // if(myArtsCategory) {
            //     resultByCategories['My Arts'] = myArtsCategory;
            // }
            if (myArtsCategory) {
                resultByCategories = {
                    'My Arts': myArtsCategory,
                    ...resultByCategories
                };
            }
            if (moreCategory) {
                resultByCategories['More'] = moreCategory;
            }
            return resultByCategories;
        },
        getArtTopLeft(artId, artSizeId, height, width, arc) {
            var newArc = Math.abs(arc) > 90 ? Math.abs(arc) - 90 : Math.abs(arc);
            var artWidth = this.store.allArts.value[artId].sizes[artSizeId].dstfile.pixelWidth * (this.store.currentEditingProps.dpi / 254.0);
            var artHeight = this.store.allArts.value[artId].sizes[artSizeId].dstfile.pixelHeight * (this.store.currentEditingProps.dpi / 254.0);
            var artBoxWidth = (Math.cos((Math.PI / 180) * Math.abs(newArc)) * artWidth) + (Math.sin((Math.PI / 180) * Math.abs(newArc)) * artHeight);
            var artBoxHeight = (Math.cos((Math.PI / 180) * Math.abs(newArc)) * artHeight) + (Math.sin((Math.PI / 180) * Math.abs(newArc)) * artWidth);
            var top = 0;
            var left = 0;
            if (artBoxHeight > artBoxWidth) {
                top = 0;
                left = (width - (artBoxWidth * (height / artBoxHeight))) / 2;
            } else if (artBoxWidth > artBoxHeight) {
                top = (height - (artBoxHeight * (width / artBoxWidth))) / 2;
                left = 0;
            } else {
                top = 0;
                left = 0;
            }
            return {
                top: top,
                left: left
            };
        },
        async addArtToDesign() {
            this.selectedButton.push('chooseArt');
            var art = Object.values(this.getArtBySearchGroupByCategories())[0].artsList[0];
            var sizeObj = Object.values(this.store.getAllArtSizesWithVirtualSizes(art.artID))[0];
            (this.artPreview = {
                imageName: this.store.currentEditingProps.imageToPreview,
                artID: art.artID,
                artSizeID: sizeObj.sizeID,
                colors: art.defaultColors.map(
                    (x) => x
                ),
                artArc: 0,
                location: {
                    x: 0,
                    y: 0,
                    arc: 0
                },
            }),
            this.store.addArtToDesign(
                this.store.currentEditingProps.productId,
                this.store.currentEditingProps.variantId,
                this.artPreview,
                //this.store.currentEditingProps.dpi,
                sizeObj.scale
                // this.imageToPreview,
                // art,
                // Object.values(art.sizes).find((x) => x.isAvailable == true).sizeID
            );
            this.store.currentEditingProps.currentPreviewIndex =
                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                .imgVariants[this.store.currentEditingProps.imageToPreview].arts.length - 1;
            this.store.currentEditingProps.currentPreview = "art";
            await this.changeStyleByRef('art');
            // this.newArt = null;
            // this.changeSelectedArt = false;
        },
        async changeArt(art, index) {
            // var artSizeID = Object.values(art.sizes)[0].sizeID;
            var artSizeID = this.store.getAllArtSizes(art.artID)[0].sizeID;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                    this.store.currentEditingProps.variantId
                ].imgVariants[this.store.currentEditingProps.imageToPreview].arts[index].artID =
                art.artID;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].arts[
                index
            ].artSizeID = artSizeID;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                    this.store.currentEditingProps.variantId
                ].imgVariants[this.store.currentEditingProps.imageToPreview].arts[index].colors =
                art.defaultColors.map((x) => x);

            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].arts[
                index
            ].dragTransform.width = this.store.allArts.value[art.artID].sizes[artSizeID].dstfile.pixelWidth * this.store.currentEditingProps.dpi / 254;
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].arts[
                index
            ].dragTransform.height = this.store.allArts.value[art.artID].sizes[artSizeID].dstfile.pixelHeight * this.store.currentEditingProps.dpi / 254;

            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].arts[
                index
            ].dragTransform.scale.scaleX = 1;

            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                this.store.currentEditingProps.variantId
            ].imgVariants[this.store.currentEditingProps.imageToPreview].arts[
                index
            ].dragTransform.scale.scaleY = 1;
            await this.changeStyleByRef('art');
        },
        delArt(index) {
            this.store.delArt(
                this.store.currentEditingProps.productId,
                this.store.currentEditingProps.variantId,
                this.store.currentEditingProps.imageToPreview,
                index
            );
            this.store.currentEditingProps.currentPreviewIndex = -1;
        },
        increaseSize(index) {
            this.store.currentEditingProps.currentPreviewIndex = index;
            this.store.currentEditingProps.currentPreview = "art";
            this.increaseArtSize(index);
        },
        decreaseSize(index) {
            this.store.currentEditingProps.currentPreviewIndex = index;
            this.store.currentEditingProps.currentPreview = "art";
            this.decreaseArtSize(index);
        },
    }
};
</script>

<style scoped>
.design-side {
    height: 334px;
    top: 555px;
    left: 968px;
}

.element-div {
    height: 240px;
    top: 9px;
    border-radius: 12px;
    border: 0.4px solid var(--3, #8A8A8A);
    margin-bottom: 5px;
}

span.ele-title {
    display: flex;
    gap: 10px;
    align-items: center;
}

.art-categories-container {
    overflow-y: auto;
    max-height: 90px;
}

span.art-category-title {
    font-size: 12px;
}

.colors-select-line {
    display: flex;
    gap: 15px;
    margin-top: 10px;
    flex-wrap: wrap;
}

/* .colors-select-line>div {
    margin-right: 20px;
} */

.colors-select-line>svg {
    margin-right: 8px;
}

.change-size-container {
    
    padding-left: 0px;
    border: none;
}

.search-container {
    /* margin-left: 140px; */
    /* margin-left: 160px; */
    /* margin-right: 2%; */
    border: 1px solid #D9D9D9;
    background: #FFFFFF;
    width: 220px;
    height: 32px;
    top: 524px;
    border-radius: 4px;
    margin-right: 10px;
}

.search-container img {
    margin-left: 5px;
    border: 1.2px solid var(--, #2D2D2D);
    width: 13.33px;
    height: 13.33px;
    top: 1.33px;
    left: 1.33px;

}

.ele-input {

    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    text-align: left;
    width: 70%;
    height: 16px;
    top: 531px;
    left: 1358px;
    border: none
}

.ele-input::placeholder {
    color: #D2D2D2;
    font-family: Roboto;

}

.ele-input:focus {
    outline: none;
}

.btn-add-element {
    cursor: pointer;
    width: 119px;
    height: 32px;
    top: 720px;
    left: 968px;
    gap: 0px;
    border-radius: 12px;
    background: #72984F12;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.41px;
    text-align: left;
    color: black;
}

.toggle-switch-art {
    display: flex;
    padding: 5px;
    /* width: 80%; */
    align-items: center;
    justify-content: flex-start;
    row-gap: 15px;
    column-gap: 15px;
}

.toggle-switch-art button {
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    line-height: 18.75px;
    text-align: center;
    color: var(--3, #8A8A8A);
    border: none;
    border-radius: 12px;
    cursor: pointer;
}

.toggle-switch-art button.active {
    border-radius: 18px;
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 18.75px;
    letter-spacing: 0%;
    color: #2D2D2D;
    background: #72984F2E;
    padding: 7px 20px;
}

.remove-container {
    cursor: pointer;
    margin-right: 2%;
    height: fit-content;
}

.art-categories-container {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin: 20px;
}
.art-category-title{
    display: flex;
    align-items: flex-start;
    flex-direction: column;

}
.gallery-elements {
    max-height: 25vh;
    position: relative;
    display: flex;
    width: 100%;
    gap: 8px;
    padding: 10px;
    flex-wrap: wrap;
}

.gallery-item {
    background: #EDEDED;
    border-radius: 4px;
    width: 73px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    position: relative;
}

.gallery-item-active {
    border: 1px solid #2D2D2D
}

</style>